(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kst-lp-base"] && !Shopify.designMode) return;
  try {
    (function(){
  if (window.__kstLpInit) return;
  window.__kstLpInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(){
    // scroll reveal
    if ('IntersectionObserver' in window && !reduce){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      document.querySelectorAll('.kst-reveal').forEach(function(el){ io.observe(el); });
    } else {
      document.querySelectorAll('.kst-reveal').forEach(function(el){ el.classList.add('is-in'); });
    }

    // smooth scroll: every [data-kst-scroll] -> the offer section
    document.querySelectorAll('[data-kst-scroll]').forEach(function(a){
      a.addEventListener('click', function(ev){
        var target = document.getElementById('kst-offer');
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // sticky mobile CTA: show after hero, hide at offer
    var sticky = document.getElementById('kst-sticky');
    var hero = document.querySelector('[data-kst-hero]');
    var offer = document.getElementById('kst-offer');
    if (sticky && hero && 'IntersectionObserver' in window){
      var so = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.target === hero){ sticky.classList.toggle('is-show', !e.isIntersecting && window.innerWidth <= 900); }
          if (e.target === offer && e.isIntersecting){ sticky.classList.remove('is-show'); }
        });
      }, { threshold: 0 });
      so.observe(hero);
      if (offer) so.observe(offer);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
  } catch(e) { console.error(e); }
})();

})();
